import React from "react"
//import { NIL as UUID_NIL } from 'uuid'
import {
    Create,
    usePermissions,
} from "react-admin"
import { NewActionsTabs } from "components/ui/layouts"
import Form from "./form"


function DeviceCreate(props: React.PropsWithChildren): JSX.Element  {
    const { permissions } = usePermissions()

    return (
        <Create redirect="show" actions={<NewActionsTabs />}>
            <Form newRecord />
        </Create>
    )
}

export default DeviceCreate